import React, {Component} from 'react';
import Navbar from '../navbar/topnav'

export default class NotFound extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {
    const clicker = this.props.history ? this.props.history.goBack : null;
    return (
      <div className="container-fluid">
      <Navbar {...this.props} menucontext="sitelist" siteFormat={this.state.displayFormat} parentUpdate={this.parentUpdate} onChange={this.siteFilter} />
      <div style={{height: "80px"}} />
      <div className="alert alert-dismissible alert-danger">
        <button type="button" className="close" data-dismiss="alert" onClick={clicker}>&times;</button>
        <strong>Missing Page</strong> There is nothing here.
          <button onClick={clicker} className="btn btn-link alert-link align-baseline">
            Click to go back</button>
          and try again.
      </div>
    </div>
    );
  }
}
